import React from "react";

function Footer() {
  return (
    <>
      <div className="footer">
        <div className="copyright">
          <p>
            <b>&copy;</b> All Rights Reserved to xyz Company
          </p>
        </div>
        <div className="develop">
          <p>Design and Developed by Lkk Tech Solutions</p>
        </div>
      </div>
    </>
  );
}
export default Footer;
